import React from 'react';
import { Card, ErrorWrapper } from '../../components';
import { RemoveButton } from '../RemoveButton';
export const CardSection = ({ name, spec, input, meta, children, }) => {
    const removeButton = React.useMemo(() => {
        if (spec.required || !input.value) {
            return null;
        }
        return React.createElement(RemoveButton, { onDrop: input.onDrop, name: name });
    }, [spec.required, input.value, input.onDrop, name]);
    return (React.createElement(Card, { name: name, title: spec.viewSpec.layoutTitle, description: spec.viewSpec.layoutDescription, actions: removeButton, alwaysOpen: true },
        React.createElement(ErrorWrapper, { name: name, meta: meta, withoutChildErrorStyles: true }, children)));
};
